import React, { useState, useEffect } from "react";

import StarRating from "../intern/starRating";
import AgencyOfferCard from "./agencyOfferCard";

import { ReactComponent as LocationIcon } from '../../assets/img/ico/map-pin.svg';
import { ReactComponent as BuildingIcon } from '../../assets/img/ico/home.svg';
import { ReactComponent as ClockIcon } from '../../assets/img/ico/calendar.svg';
import { ReactComponent as PhoneIcon } from '../../assets/img/ico/phone.svg';
import { ReactComponent as SearchIcon } from '../../assets/img/ico/search-icon.svg';

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

import AgencyLogo from '../../assets/img/logo.svg'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const AgencyDetailView = () => {
    const agencyData = {
        name: "Hotel Fontaine",
        rating: 4,
        address: "34 chemin des Arène 06100 NICE",
        type: "l'hôtellerie restauration",
        hours: "8h30 / 17h00 - Lun. au Vend.",
        phone: "+33 (0) 4 05 06 05 06",
        imageUrl: AgencyLogo,
        position: [43.694915, 7.255006]
    };

    const [offersData, setOffersData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("Plus récent");
    const [sortDropdownOpen, setSortDropdownOpen] = useState(false);

    const mapZoom = 13;

    const sortOptions = ["Plus récent", "Plus ancien"];

    const fetchOffersData = async () => {
        await new Promise(resolve => setTimeout(resolve, 150)); 


        setOffersData([
            { id: 1, title: "Receptioniste H/F", relativeDate: "Aujourd'hui", dateRange: "Mer. 3 janvier → lun. 8 janvier", daysWorked: "6j travaillés", location: "Rouen (76)", salary: "De 10.25 €/heure", link: "#" },
            { id: 2, title: "Receptioniste H/F", relativeDate: "Aujourd'hui", dateRange: "Mer. 3 janvier → lun. 8 janvier", daysWorked: "6j travaillés", location: "Rouen (76)", salary: "De 10.25 €/heure", link: "#" },
            { id: 3, title: "Receptioniste H/F", relativeDate: "Aujourd'hui", dateRange: "Mer. 3 janvier → lun. 8 janvier", daysWorked: "6j travaillés", location: "Rouen (76)", salary: "De 10.25 €/heure", link: "#" },
            { id: 4, title: "Receptioniste H/F", relativeDate: "Aujourd'hui", dateRange: "Mer. 3 janvier → lun. 8 janvier", daysWorked: "6j travaillés", location: "Rouen (76)", salary: "De 10.25 €/heure", link: "#" },
            { id: 5, title: "Receptioniste H/F", relativeDate: "Aujourd'hui", dateRange: "Mer. 3 janvier → lun. 8 janvier", daysWorked: "6j travaillés", location: "Rouen (76)", salary: "De 10.25 €/heure", link: "#" },
            { id: 6, title: "Receptioniste H/F", relativeDate: "Aujourd'hui", dateRange: "Mer. 3 janvier → lun. 8 janvier", daysWorked: "6j travaillés", location: "Rouen (76)", salary: "De 10.25 €/heure", link: "#" },
        ]);
    };

    useEffect(() => {
        fetchOffersData();
    }, []); 

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSortSelect = (value) => {
        setSortOrder(value);
        setSortDropdownOpen(false);
    };

    return (
        <section className="adv-layout">
            <h1 className="adv-main-title">Fiche détaillée agence</h1>
            <div className="adv-card">
                <div className="adv-details-section">
                    <div className="adv-header">
                        <div className="adv-logo-placeholder">
                            <img src={agencyData.imageUrl} alt={`${agencyData.name} logo`} className="adv-logo" />
                        </div>
                        <div className="adv-name-rating">
                            <h2>{agencyData.name}</h2>
                            <StarRating rating={agencyData.rating} />
                        </div>
                    </div>
                    <div className="adv-info-list">
                        <div className="adv-info-item">
                            <LocationIcon className="adv-icon" />
                            <p>{agencyData.address}</p>
                        </div>
                        <div className="adv-info-item">
                            <BuildingIcon className="adv-icon" />
                            <p>{agencyData.type}</p>
                        </div>
                        <div className="adv-info-item">
                            <ClockIcon className="adv-icon" />
                            <p>{agencyData.hours}</p>
                        </div>
                        <div className="adv-info-item">
                            <PhoneIcon className="adv-icon" />
                            <p>{agencyData.phone}</p>
                        </div>
                    </div>
                </div>
                <div className="adv-map-section">
                    <MapContainer center={agencyData.position} zoom={mapZoom} scrollWheelZoom={false} className="adv-map-container">
                        <TileLayer
                            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                        />
                        <Marker position={agencyData.position}>
                            <Popup>
                                {agencyData.name} <br /> {agencyData.address}
                            </Popup>
                        </Marker>
                    </MapContainer>
                    <button className="btn fill green adv-contact-button">
                        Contacter
                    </button>
                </div>
            </div>

            <div className="adv-offers-section">
                <h2 className="adv-offers-title">Offres associées</h2>

                <div className="adv-offers-controls">
                    <div className="adv-search-bar">
                         <SearchIcon className="adv-search-icon" />
                        <input
                            type="text"
                            placeholder="Effectuer une recherche par secteur d'activités, ville..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="adv-search-input"
                        />
                    </div>
                    <button className="btn fill green adv-search-button">Rechercher</button>

                    <div className="adv-sort-control">
                        <span>Trier par</span>
                        <div className="custom-dropdown" onClick={() => setSortDropdownOpen(!sortDropdownOpen)}>
                            <button type="button" className="custom-dropdown-button">
                                {sortOrder}
                                <i className={`fa-solid fa-chevron-down ${sortDropdownOpen ? "rotate" : ""}`}></i>
                            </button>

                            {sortDropdownOpen && (
                                <ul className="custom-dropdown-menu">
                                    {sortOptions.map((option) => (
                                        <li
                                            key={option}
                                            onClick={() => handleSortSelect(option)}
                                            className={`custom-dropdown-item ${
                                                sortOrder === option ? "active" : ""
                                            }`}
                                        >
                                            {option}
                                            {sortOrder === option && (
                                                <i className="fa-solid fa-check check-icon"></i>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>

                 <div className="adv-offers-grid">
                    {offersData.length > 0 ? (
                        offersData.map(offer => (
                            <AgencyOfferCard key={offer.id} offer={offer} />
                        ))
                    ) : (
                        <p>Chargement des offres...</p>
                    )}
                </div>
            </div>
        </section>
    )
}

export default AgencyDetailView;